import { useState } from 'react';
import ProductGallery from './components/ProductGallery';
import ProductInfo from './components/ProductInfo';
import ProductTabs from './components/ProductTabs';
import RelatedProducts from './components/RelatedProducts';

export default function ProductGPUPage() {
  const [selectedImage, setSelectedImage] = useState(0);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <a href="/" className="flex items-center space-x-3">
              <img 
                src="https://static.readdy.ai/image/7d05fb9254e2e5292eff42edf988a3d0/779228b5c77a05b3b3480e0272df8ea5.png" 
                alt="에코브이 로고" 
                className="h-10 w-auto"
              />
            </a>
            <div className="flex items-center space-x-8">
              <a href="/" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">홈</a>
              <a href="/product/ram" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">RAM</a>
              <a href="/product/cpu" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">CPU</a>
              <a href="/product/detail" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">SSD</a>
              <a href="/product/privacy-film" className="text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap">정보보안필름</a>
            </div>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center space-x-2 text-sm">
            <a href="/" className="text-gray-500 hover:text-teal-600 transition-colors">홈</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <a href="/#categories" className="text-gray-500 hover:text-teal-600 transition-colors">제품 카테고리</a>
            <i className="ri-arrow-right-s-line text-gray-400"></i>
            <span className="text-gray-900 font-medium">그래픽카드</span>
          </div>
        </div>
      </div>

      {/* Product Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <ProductGallery selectedImage={selectedImage} setSelectedImage={setSelectedImage} />
          <ProductInfo />
        </div>

        {/* Product Tabs */}
        <div className="mt-16">
          <ProductTabs />
        </div>

        {/* Bulk Order Section */}
        <div className="mt-16 bg-gradient-to-br from-teal-50 to-emerald-50 rounded-2xl p-8 border border-teal-100">
          <div className="max-w-3xl mx-auto text-center">
            <div className="w-16 h-16 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-building-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">기업 및 대량 구매 견적 문의</h3>
            <p className="text-gray-600 mb-8">10개 이상 대량 구매 시 특별 할인 혜택을 제공해드립니다. 게이밍 센터, PC방, 크리에이터 스튜디오 등 기업 고객을 위한 맞춤 견적을 받아보세요.</p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <a href="tel:02-702-0999" className="inline-flex items-center px-6 py-3 bg-teal-600 text-white rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
                <i className="ri-phone-line mr-2"></i>
                02-702-0999
              </a>
              <a href="mailto:ecov2025@naver.com" className="inline-flex items-center px-6 py-3 bg-white text-teal-600 border-2 border-teal-600 rounded-lg hover:bg-teal-50 transition-colors whitespace-nowrap">
                <i className="ri-mail-line mr-2"></i>
                ecov2025@naver.com
              </a>
            </div>
          </div>
        </div>

        {/* Related Products */}
        <div className="mt-16">
          <RelatedProducts />
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gradient-to-br from-slate-800 to-slate-900 text-white mt-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/7d05fb9254e2e5292eff42edf988a3d0/779228b5c77a05b3b3480e0272df8ea5.png" 
                alt="에코브이 로고" 
                className="h-10 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-gray-300 text-sm leading-relaxed">(주)에코브이는 RAM, CPU, SSD 등 컴퓨터 주변기기와 정보보안필름을 해외에서 제조·수입·판매하는 전문 기업입니다.</p>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-4">연락처</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <p className="flex items-start"><i className="ri-map-pin-line mr-2 mt-1 flex-shrink-0"></i><span>서울시 용산구 새창로 181 선인상가 21동 4층 4086호</span></p>
                <p className="flex items-center"><i className="ri-phone-line mr-2 flex-shrink-0"></i>02-702-0999</p>
                <p className="flex items-center"><i className="ri-mail-line mr-2 flex-shrink-0"></i>ecov2025@naver.com</p>
                <p className="flex items-center"><i className="ri-global-line mr-2 flex-shrink-0"></i>www.eco-v.co.kr</p>
              </div>
            </div>
            <div>
              <h4 className="font-bold text-lg mb-4">사업자 정보</h4>
              <div className="space-y-2 text-sm text-gray-300">
                <p>대표자: 박종석</p>
                <p>사업자등록번호: 110111-0921242</p>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-sm text-gray-400">
            <p>&copy; 2025 (주)에코브이. All rights reserved. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-teal-400 transition-colors">Powered by Readdy</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
}